import { Box, Grid, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import cenik from "./cenik.webp";
import { fontText, fontTitle } from '../MainPage/styles';

export default function Cenik() {
    const col = useMediaQuery(`(max-width:1200px)`);

    return (
        <Grid container spacing={{ xs: 2, md: 6, lg: 6, xl: 6 }} columns={{ xs: 24, sm: 24, md: 24, lg: 24 }}
            sx={{
                pb: '120px',
                pt: { xs: 0, md: 0, lg: 0, xl: '120px' },
                textAlign: 'left', scrollMarginTop: '0px', alignItems: 'flex-start',
            }}
            id="cenik">
            <Grid size={{ xs: 24, sm: 24, md: 24, lg: 11 }}>
                <Typography sx={{ ...fontTitle, pb: '16px' }}>
                    Ceník
                </Typography>
                <Typography sx={{ ...fontText }} component={'ul'}>
                    <li style={{ marginTop: '16px' }}>
                        <b>Čištění čalouněného nábytku:</b>
                        <ul>
                            <li>Malá sedačka (přímá, 2–3 místa): <b>od 750 Kč</b></li>
                            <li>Velká sedačka (rohová nebo tvar U): <b>od 1&nbsp;250 Kč</b></li>
                            <li>Kancelářské křeslo / jídelní židle: <b>150–200 Kč / kus</b></li>
                        </ul>
                    </li>

                    <li style={{ marginTop: '16px' }}>
                        <b>Hloubkové čištění koberců:</b>
                        <ul>
                            <li>Koberec s krátkým vlasem: <b>50 Kč / m²</b></li>
                            <li>Koberec s dlouhým vlasem (shaggy): <b>70 Kč / m²</b></li>
                        </ul>
                    </li>

                    <li style={{ marginTop: '16px' }}>
                        <b>Ochranná impregnace (odpuzuje tekutiny a usnadňuje údržbu):</b>
                        <ul>
                            <li>Impregnace kancelářského křesla: <b>150 Kč</b></li>
                            <li>Impregnace malé sedačky: <b>350 Kč</b></li>
                            <li>Impregnace velké sedačky: <b>450 Kč</b></li>
                        </ul>
                    </li>

                    <li style={{ marginTop: '16px' }}>
                        <b>Doprava a výjezd:</b>
                        <ul>
                            <li>Doprava po Brně: <b>99 Kč</b></li>
                            <li>Doprava mimo Brno: <b>12 Kč / km</b> (počítáno pro cestu tam i zpět)</li>
                            <li>Minimální hodnota zakázky: <b>1&nbsp;000 Kč + doprava</b></li>
                        </ul>
                    </li>

                </Typography>
            </Grid>
            <Grid size={{ xs: 24, sm: 24, md: 24, lg: 13 }} sx={{ display: 'flex', justifyContent: { xs: 'normal', sm: 'normal', md: 'flex-end', lg: 'normal' } }}>
                <Box component={'img'} src={cenik} sx={{
                    width: '100%', maxWidth: { xs: '100%', sm: '100%', md: '600px', lg: '100%' }, height: 'auto', display: 'block',
                    pt: { xs: '80px', sm: '50px', md: '50px', lg: '0px' }
                }} />
            </Grid>
        </Grid>
    )
} 